import React, { useRef } from "react";
import { onKeyDown } from "helpers/dom-events";
import { ReactComponent as ArrowDown } from "assets/svgs/arrow-down-bold.svg";
import clsx from "clsx/lite";

const CommonDropdown = ({
	icon: Icon,
	className,
	label,
	displayName,
	selectedValue = "",
	options,
	handleChange,
	useKeyAsOptionValue = false,
	...others
}) => {
	const selectRef = useRef(null);

	return (
		<div className={clsx("relative w-11/12 md:w-4/5 mx-auto", className)}>
			<div
				className={clsx(
					"border text-black flex gap-2 py-3.5 px-4 outline-focus-ay11",
					options?.length > 1 && "border-secondary rounded-[60px]",
				)}
				tabIndex={0}
				onKeyDown={onKeyDown(() => selectRef.current.focus())}
				{...others}
			>
				{Icon && <div className="flex items-center justify-center w-[10%]">
					<span className="inline-flex align-middle items-center justify-center h-5">
						<Icon className="h-full w-auto" />
					</span>
				</div>}
				<div className="flex items-center justify-between w-4/5">
					{label && <span className="font-bold min-w-1/2">{label}: </span>}
					<span className="min-w-1/2">{displayName}</span>
				</div>
				{options?.length > 1 && (
					<div className="flex w-1/12 items-center justify-center">
						<span className="inline-flex align-middle items-center justify-center">
							<ArrowDown className="h-full w-auto opacity-50" role="presentation" aria-hidden="true" />
						</span>
					</div>
				)}
			</div>
			<div
				className="opacity-0 top-0 left-0 w-full h-full absolute flex items-center box-border text-secondary overflow-hidden p-0"
			>
				{options?.length > 1 &&
					<select
						ref={selectRef}
						name={others["aria-label"] || ""}
						value={selectedValue}
						defaultValue=""
						onChange={handleChange}
						className="select-option h-full outline-0 border-[0] cursor-pointer p-2 w-full bg-white"
					>
						{options.map((opt => <option key={opt._key || opt.id} value={useKeyAsOptionValue ? opt._key : opt.id}>
							{opt.name}
						</option>))}
					</select>}
			</div>
		</div>
	);
};

export default CommonDropdown;